import request from "../utils/request.js"
// 获取政策列表
export function getQueryDirectoriesApi(params) {
    return request({
        url: "/directories/queryDirectories/"+params,
        method: "get",
    })
}
// 新型主体统计 http://8.140.169.214/enterpriseClassify/subjectStatistics/白桥镇
export function getBodyStatisticsDataApi(params) {
    return request({
        url: "/enterpriseClassify/subjectStatistics/" + params,
        method: "post",
        // data: params,
    })
}
// 供需服务发布统计
export function getSupplyServiceStatisticsApi(params) {
    return request({
        url: "/enterpriseClassify/supplyServiceStatistics/" + params,
        method: "post",
    })
}
// 全部类型数据列表
export function getQueryAllDataApi(params) {
    return request({
        url: "/enterpriseClassify/queryAllData/"+params,
        method: "post",
    })
}
// 合作社、家庭农场、服务组织、龙头企业详细信息接口
export function getQueryByIdForMultipleApi(params) {
    return request({
        url: "/enterpriseClassify/queryById_HZS_JTLC_FWZZ_LTQY/"+params,
        method: "post",
    })
}
// 益农信息社
export function getQueryByIdForInformationApi(params) {
    return request({
        url: "/enterpriseClassify/queryById_YLXXS/"+params,
        method: "post",
    })
}
// 产业园区
export function getQueryByIdForParkApi(params) {
    return request({
        url: "/enterpriseClassify/queryById_CYYQ/"+params,
        method: "post",
    })
}
// 大棚点位
export function getGreenhouseApi(params) {
    return request({
        url: "/enterpriseClassify/queryGreenhouse/"+params,
        method: "post",
    })
}
// 大棚详情
export function getGreenhouseDetailsApi(params) {
    return request({
        url: "/enterpriseClassify/queryEquipmentData/"+params,
        method: "post",
    })
}
// 模糊查询 http://8.140.169.214/enterpriseClassify/queryName/{name}
export function getFuzzyApi(params) {
    return request({
        url: "/enterpriseClassify/queryName/"+params,
        method: "post",
    })
}
// 获取当前乡镇现代产业园
export function getTownIndustrialApi(params) {
    return request({
        url: "/enterpriseClassify/townIndustrial/"+params,
        method: "post",
    })
}
// 获取当前乡镇产业园详情
export function getIndustrialParksDataApi(params) {
    return request({
        url: "/enterpriseClassify/industrialParksData/"+params,
        method: "post",
    })
}